import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

export class CustomUrlSerializer implements UrlSerializer {
	private defaultSerializer = new DefaultUrlSerializer();

	parse(url: string): UrlTree {
		return this.defaultSerializer.parse(url);
	}

	serialize(tree: UrlTree): string {
		const path = this.defaultSerializer.serialize(tree);
		return path.replace(/%5B/g, '[').replace(/%5D/g, ']');
	}
}
